module.exports = __webpack_public_path__ + "static/img/pic_rjyf_rjfw_yw_nor.11ef59f2.png";